import React from "react";
import { Link } from "react-router-dom";
import Logo from "../elements/Logo";

function HeaderStatic({ light, logoSource, toggleMenu, headerToggler }) {
  const handleClasses = () => {
    let classes = "desktop-header-1 d-flex align-items-start flex-column";
    if (light & toggleMenu) {
      classes += " light open";
    } else if (toggleMenu) {
      classes += " open";
    } else if (light) {
      classes += " light";
    }
    return classes;
  };
  
  const handleMobileClasses = () => {
    let classes = "mobile-header-1";
    if (light & toggleMenu) {
      classes += " light open";
    } else if (toggleMenu) {
      classes += " open";
    } else if (light) {
      classes += " light";
    }
    return classes;
  };
  
  return (
    <>
      <header className={handleMobileClasses()}>
        <div className="container">
          <div className="menu-icon d-inline-flex mr-4">
            <button onClick={headerToggler}>
              <span></span>
            </button>
          </div>
          <Logo logoSource={logoSource} />
        </div>
      </header>
      <header className={handleClasses()}>
        <Logo logoSource={logoSource} />
        <nav>
          <ul className="vertical-menu">
            <li>
              <Link to="/">
                <i className="icon-home"></i>Trang chủ
              </Link>
            </li>
            <li>
              <Link 
                to="/"
                onClick={() => {
                  window.location.href = '/#section-about';
                }}
              >
                <i className="icon-user-following"></i>Giới thiệu
              </Link>
            </li>
            <li>
              <Link 
                to="/"
                onClick={() => {
                  window.location.href = '/#section-services';
                }}
              >
                <i className="icon-briefcase"></i>Công việc
              </Link>
            </li>
            <li>
              <Link 
                to="/"
                onClick={() => {
                  window.location.href = '/#section-testimoninal';
                }}
              >
                <i className="icon-layers"></i>Phản hồi
              </Link>
            </li>
            <li>
              <Link 
                to="/bai-viet"
                className={window.location.pathname === '/bai-viet' || window.location.pathname.startsWith('/bai-viet/') ? 'active' : ''}
              >
                <i className="icon-note"></i>Bài viết
              </Link>
            </li>
            <li>
              <Link 
                to="/"
                onClick={() => {
                  window.location.href = '/#section-contact';
                }}
              >
                <i className="icon-bubbles"></i>Liên hệ
              </Link>
            </li>
          </ul>
        </nav>

        <div className="footer">
          <span className="copyright">
            &copy; {new Date().getFullYear()}
          </span>
        </div>
      </header>
    </>
  );
}

export default HeaderStatic;